import { render } from "./hrm-announcement-modal.vue?vue&type=template&id=3046dc2c&scoped=true"
import script from "./hrm-announcement-modal.vue?vue&type=script&lang=js"
export * from "./hrm-announcement-modal.vue?vue&type=script&lang=js"

import "./hrm-announcement-modal.vue?vue&type=style&index=0&id=3046dc2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3046dc2c"]])

export default __exports__